import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { ApiError } from '../api/client.js';
import { useAuth } from '../auth/useAuth.js';
import { Brand } from '../components/Brand.js';
import { ThemeToggle } from '../components/ThemeToggle.js';

export function LoginPage() {
  const { authenticated, loading, login } = useAuth();
  const [username, setUsername] = useState('admin');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  if (!loading && authenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="login-shell">
      <div className="login-theme">
        <ThemeToggle />
      </div>
      <form
        className="card login-card stack"
        onSubmit={(event) => {
          event.preventDefault();
          setPending(true);
          setError(null);
          void login(username, password)
            .catch((err: unknown) => {
              setError(err instanceof ApiError ? err.message : 'تعذر تسجيل الدخول.');
            })
            .finally(() => setPending(false));
        }}
      >
        <div className="login-head">
          <Brand to="/login" />
          <div>
            <h1>تسجيل دخول المسؤول</h1>
            <p className="muted">حساب مسؤول واحد. تستمر الجلسة حتى تسجيل الخروج أو انتهاء صلاحيتها.</p>
          </div>
        </div>
        <label>
          اسم المستخدم
          <input
            type="text"
            autoComplete="username"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
          />
        </label>
        <label>
          كلمة المرور
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </label>
        {error && <p className="error">{error}</p>}
        <button className="btn" type="submit" disabled={pending}>
          {pending ? 'جارٍ تسجيل الدخول…' : 'تسجيل الدخول'}
        </button>
      </form>
    </div>
  );
}
